import './Skeleton.css';

// Single shimmer placeholder. Pass width/height/radius for one-off shapes.
export function Skeleton({ width, height, radius, className = '', style }) {
  return (
    <span
      className={`skeleton ${className}`}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

// Full-page placeholder for the admin-table list pages (Providers, Payers, Users…).
// Mirrors the header + table-card layout so the page doesn't jump when data lands.
// `columns` should match the real table's column count for a convincing shape.
export function AdminTableSkeleton({ columns = 4, rows = 6, avatarFirstCol = true }) {
  return (
    <div className="admin-page" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading…</span>

      <div className="admin-header">
        <div className="admin-header-text">
          <Skeleton className="skeleton-text" style={{ height: 26, width: 220 }} />
          <Skeleton className="skeleton-text" style={{ height: 14, width: 340, marginTop: 10 }} />
        </div>
        <Skeleton style={{ height: 40, width: 140, borderRadius: 10 }} />
      </div>

      <div className="admin-table-card" aria-hidden="true">
        <div className="skeleton-table">
          <div className="skeleton-table-row skeleton-table-row--head">
            {Array.from({ length: columns }).map((_, i) => (
              <Skeleton key={i} className="skeleton-text skeleton-th" />
            ))}
          </div>
          {Array.from({ length: rows }).map((_, r) => (
            <div className="skeleton-table-row" key={r}>
              {Array.from({ length: columns }).map((_, c) => (
                c === 0 && avatarFirstCol ? (
                  <div className="skeleton-name-cell" key={c}>
                    <Skeleton style={{ width: 32, height: 32, borderRadius: 8 }} />
                    <Skeleton className="skeleton-text" style={{ maxWidth: 160 }} />
                  </div>
                ) : (
                  <Skeleton key={c} className="skeleton-text" style={{ maxWidth: c === columns - 1 ? 90 : undefined }} />
                )
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
